export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11406.a3fc61b5.jpg";